import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DataTable from 'react-data-table-component';
import { Spinner } from 'react-bootstrap';
import { useDrag } from 'react-dnd';

import { getQuestionsByProvider } from '../../../../../_actions/question-library.action';

const dataTableColumns = [
  {
    name: 'Question',
    sortable: false,
    cell: question => <QuestionComponent question={question} />
  }
]

const QuestionComponent = ({ question }) => {
  const [{ isDragging }, drag] = useDrag({
    item: { type: question.resource.type, question },
    collect: monitor => ({
      isDragging: !!monitor.isDragging()
    })
  });

  return <div
    ref={drag}
    style={{
      cursor: 'move',
      backgroundColor: '#ffffff',
      padding: '10px',
      opacity: isDragging ? 0.1 : 1
    }}>
    {question.resource.text.length > 75 ? question.resource.text.substring(0, 75) + '...' : question.resource.text}
  </div>
};

const FilterComponent = ({ filterText, onFilter, onClear }) => (
  <div className="input-group">
    <input
      value={filterText}
      onChange={onFilter}
      type="text"
      className="form-control"
      placeholder="Search for question..."
      aria-label="Search for question..."
      aria-describedby="clear-search" />
    <div className="input-group-append">
      <button onClick={onClear} className="btn btn-outline-secondary" type="button" id="clear-search">X</button>
    </div>
  </div>
);

export default function QuestionLibrary() {
  const isLoading = useSelector(state => state.questionLibrary.isLoading);
  const collection = useSelector(state => state.questionLibrary.collection);

  const dispatch = useDispatch();

  const [filterText, setFilterText] = useState('');
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const filteredData = collection.data.filter((question) => {
    return question.resource.text && question.resource.text.toLowerCase().includes(filterText.toLowerCase());
  });

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText('');
      }
    };

    return <FilterComponent
      onFilter={e => setFilterText(e.target.value)}
      onClear={handleClear}
      filterText={filterText} />
  }, [filterText, resetPaginationToggle]);


  useEffect(() => {
    dispatch(getQuestionsByProvider());
  }, [dispatch]);

  return <div className="row">
    <div className="col-lg-12">
      {isLoading &&
        <Spinner animation="border" role="status">
          <span className="sr-only">Loading...</span>
        </Spinner>
      }

      {!isLoading && collection.data.length > 0 &&
        <DataTable
          noHeader={true}
          noTableHead={true}
          columns={dataTableColumns}
          data={filteredData}
          subHeader
          subHeaderComponent={subHeaderComponentMemo}
          pagination={true}
          customStyles={{ cells: { style: { fontSize: '14px' }, }, }}
        />
      }
    </div>
  </div>
}